import SendEmail from '@features/auth/components/SendEmail';
import { sendVerificationEmail } from '@features/auth/store/auth.actions';
import GuardedRoute from '@features/layout/components/GuardedRoute';
import React from 'react';
import { useIntl } from 'react-intl';
import Head from 'next/head';
import { getAuthIsLoading } from '@features/auth/store/auth.selectors';
import { useSelector } from 'react-redux';
import { GetServerSideProps } from 'next';
import { IGetServerSideProps } from 'model/global.model';

const VerificationEmail = ({ title }: IGetServerSideProps) => {
	const { formatMessage } = useIntl();
	const isLoading = useSelector(getAuthIsLoading('sendVerificationEmail'));

	return (
		<>
			<Head>
				<title>{formatMessage({ id: 'bcs-Title-VerifyEmail' })}</title>
				<link rel='icon' href='/favicon.ico' />
				<meta
					name='viewport'
					content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
				/>
				<meta name='theme-color' content='#ffffff' />
				<meta property='og:title' content={title} key='ogTitle' />
			</Head>
			<GuardedRoute redirectTo={'/'} isAuthenticationRoute>
				<SendEmail
					action={sendVerificationEmail}
					title={formatMessage({ id: 'bcs-Auth-SendVerificationEmail' })}
					description={formatMessage({ id: 'bcs-Auth-SendVerificationEmail-Description' })}
					successMessage={formatMessage({ id: 'bcs-Auth-VerificationEmailSent' })}
					isLoading={isLoading}
				/>
			</GuardedRoute>
		</>
	);
};

export const getServerSideProps: GetServerSideProps = async () => {
	return {
		props: {
			title: 'Заяви нов имейл за верификация | Gamy.fun',
		},
	};
};

export default VerificationEmail;
